// extracted by mini-css-extract-plugin
export var details = "_lt-0";
export var inspectorPopover = "_lt-1";